import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

function EmptyState({ message = 'No data found', description }) {
  return (
    <Box className="flex flex-col items-center justify-center py-20">
      <InboxIcon className="text-gray-300 mb-4" sx={{ fontSize: 80 }} />
      <Typography variant="body1" color="text.secondary" className="font-semibold">
        {message}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" className="mt-2 text-center max-w-md">
          {description}
        </Typography>
      )}
    </Box>
  );
}

export default EmptyState;
